import React from 'react';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
// import { noteActions } from '_actions';
// import styles from './Common.module.css';

class PatientCareCenterNoteGoalsGoalDetailsSpeech extends React.Component {

    render() {
        return (

            <div>
                {'Speech Goal - ' + this.props.activityName}
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        // selectGoal: bindActionCreators(noteActions.selectGoal, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let activityName = goal.GOMGNO ? state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '';

    return {
        noteId: noteId,
        goal: goal,
        activityName: activityName,
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsSpeech = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalDetailsSpeech);
export { connectedPatientCareCenterNoteGoalsGoalDetailsSpeech as PatientCareCenterNoteGoalsGoalDetailsSpeech };

